<div class="w-auto max-w-full overflow-y-auto dark:bg-contrast-black md:rounded-lg md:bg-grey-white_smoke md:p-4">
    <div class="flex items-center justify-between p-4 lg:pt-0" *ngIf="env.PURCHASE_FLOW.SHOW_ZONE_MAP_IN_AREA_STEP">
        <div class="text-base">{{ 'SELECT_AREA_TO_TRAVEL_WITHIN' | translate }}</div>
        <div
            class="cursor-pointer text-base normal-case text-secondary dark:text-contrast-yellow"
            (click)="openZoneMap()">
            {{ 'VIEW_ZONE_MAP' | translate }}
        </div>
    </div>
    <div class="mb-4 bg-white shadow-md lg:hidden">
        <h1
            class="p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
            *ngIf="!env.PURCHASE_FLOW.SHOW_ZONE_MAP_IN_AREA_STEP">
            {{ 'SELECT_CITY' | translate }}
        </h1>
    </div>
    <div class="bg-white px-4 shadow-md md:m-0">
        <button
            class="product flex w-full items-center justify-between gap-4 border-b border-solid border-black border-opacity-10 py-4 text-left first:border-t focus:outline-none focus:ring-2 focus:ring-blue-500"
            *ngFor="let area of productAreas"
            (click)="selectArea(area.id)"
            type="button">
            <div>
                <h1 class="text-base font-bold leading-7 text-black dark:text-contrast-yellow">
                    {{ area.name | translateObjectField: null : currentLanguage }}
                </h1>
                <p class="text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow">
                    {{ area.description | translateObjectField: null : currentLanguage }}
                </p>
            </div>
            <div class="flex flex-col justify-center p-3">
                <ion-icon
                    class="text-black dark:text-contrast-yellow"
                    title="{{ 'CHEVRON_FORWARD' | translate }}"
                    aria-hidden="true"
                    name="chevron-forward-outline"></ion-icon>
            </div>
        </button>
    </div>
</div>
